window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gtm-event]').forEach((element) => {
    element.addEventListener('click', (e) => {
      // e.preventDefault();
      const label = element.dataset.gtmEvent;
      window.trackEvent(label);
    });
  });
});


window.dataLayer = window.dataLayer || [];

window.trackEvent = (label) => {
  // If gtag is available use it, otherwise push to dataLayer for GTM
  if (typeof gtag === 'function') {
    ga('event', 'button_click', { label: label });
    console.log('gtag event tracking', label);
    return;
  }

  if (Array.isArray(window.dataLayer)) {
    // Use a clear event name and params; map these inside GTM to GA4/UA as needed
    window.dataLayer.push({
      event: 'button_click',
      event_label: label,
      event_category: 'button'
    });
    console.log('dataLayer push', label);
    return;
  }

  console.warn('gtag and dataLayer are not available');
};